/* la Joie Atelier — cart-level gift note, optional birthday and checkout reassurance. */
(function(){
  var rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var cartState=null, loading=null, queue=Promise.resolve();
  function cartUrl(path){return rootPath+path.replace(/^\//,'');}
  function getCart(force){
    if(cartState&&!force)return Promise.resolve(cartState);
    if(loading&&!force)return loading;
    loading=fetch(cartUrl('cart.js'),{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){cartState=c;loading=null;return c;}).catch(function(){loading=null;return {note:'',attributes:{}};});
    return loading;
  }
  function updateCart(payload){
    queue=queue.then(function(){
      return fetch(cartUrl('cart/update.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
    }).then(function(r){return r.json();}).then(function(c){cartState=c;return c;}).catch(function(){return cartState;});
    return queue;
  }
  function makeId(prefix){return prefix+'-'+Math.random().toString(36).slice(2,9);}
  function mount(container){
    if(!container||container.querySelector('.lja-cart-personal'))return;
    var totals=container.querySelector('.cart-totals__container');
    if(!totals)return;
    var noteId=makeId('lja-gift-note'),dobId=makeId('lja-dob');
    var box=document.createElement('div');
    box.className='lja-cart-personal';
    box.innerHTML='<div class="lja-gift-note"><details><summary><span class="q">Is this a gift?</span><span class="a">Add a gift note</span></summary><div class="lja-personal-body"><label class="visually-hidden" for="'+noteId+'">Gift note</label><textarea id="'+noteId+'" maxlength="250" placeholder="Write your gift note here"></textarea><div class="count" aria-live="polite">0 / 250</div></div></details></div><div class="lja-birthday"><label for="'+dobId+'"><span class="q">Birthday <span class="optional">(optional)</span></span><span class="hint">For birthday messages and occasional personal gestures only. This does not subscribe you to marketing.</span></label><input id="'+dobId+'" type="date" autocomplete="bday"></div>';
    totals.parentNode.insertBefore(box,totals);
    var ta=box.querySelector('textarea'),count=box.querySelector('.count'),dob=box.querySelector('input[type="date"]'),noteTimer,dobTimer;
    getCart(false).then(function(c){
      if(!ta.matches(':focus'))ta.value=c.note||'';
      count.textContent=ta.value.length+' / 250';
      var attrs=c.attributes||{};
      if(!dob.matches(':focus')&&attrs['Date of Birth'])dob.value=attrs['Date of Birth'];
    });
    ta.addEventListener('input',function(){
      count.textContent=ta.value.length+' / 250';
      clearTimeout(noteTimer);
      noteTimer=setTimeout(function(){updateCart({note:ta.value});},450);
    });
    dob.addEventListener('change',function(){
      clearTimeout(dobTimer);
      dobTimer=setTimeout(function(){updateCart({attributes:{'Date of Birth':dob.value}});},100);
    });
    if(!container.querySelector('.lja-cart-reassure')){
      var reassure=document.createElement('p');
      reassure.className='lja-cart-reassure';
      reassure.textContent='Free worldwide shipping on physical orders. Duties and import taxes are calculated at checkout where applicable.';
      totals.parentNode.insertBefore(reassure,totals.nextSibling);
    }
  }
  function scan(){document.querySelectorAll('.cart-totals').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
})();
